import { render, staticRenderFns } from "./StockSorting.vue?vue&type=template&id=ec574984&scoped=true&"
import script from "./StockSorting.vue?vue&type=script&lang=js&"
export * from "./StockSorting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec574984",
  null
  
)

export default component.exports